import { Inject, Injectable } from '@angular/core';

import { Meta, Title } from '@angular/platform-browser';

import { PLATFORM_TITLE } from '../interface/environment.interface';

@Injectable()
export class MetaService {
  constructor(@Inject(PLATFORM_TITLE) private platformTitle: string, private titleService: Title, private meta: Meta) {}

  setTitle(string: string, values: string[] = [], platformTitleFirst = false) {
    this.titleService.setTitle(this.getTitle(string, values, platformTitleFirst));
  }

  getTitle(string: string, values: string[] = [], platformTitleFirst = false) {
    let content = platformTitleFirst ? this.platformTitle + ' | ' + string : string + ' | ' + this.platformTitle;

    values.forEach((_, index) => {
      content = content.replace('[[' + index + ']]', values[index] ?? '');
    });

    return content;
  }

  addOpenGraphMetaTags(title: string, description: string, url: string, image: string, values: string[] = []) {
    values.forEach((_, index) => {
      title = title.replace('[[' + index + ']]', values[index] ?? '');
      description = description.replace('[[' + index + ']]', values[index] ?? '');
    });

    this.meta.addTags([
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: url },
      { property: 'og:image', content: image },
    ]);
  }

  removeOpenGraphMetaTags() {
    this.meta.removeTag("property='og:title'");
    this.meta.removeTag("property='og:description'");
    this.meta.removeTag("property='og:url'");
    this.meta.removeTag("property='og:image'");
  }
}
